import { render, staticRenderFns } from "./multiple.vue?vue&type=template&id=066d801e&scoped=true&lang=pug"
import script from "./multiple.vue?vue&type=script&lang=js"
export * from "./multiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066d801e",
  null
  
)

export default component.exports